/* eslint-disable react/no-danger */
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';
import SportLivePeriod from './SportLivePeriod';

import styles from '../../../styles/partials/game-card.module.scss';

const propTypes = {
    game: AppPropTypes.game,
    selected: PropTypes.bool,
    small: PropTypes.bool,
    withoutLogo: PropTypes.bool,
    onClickGame: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    game: null,
    selected: false,
    small: false,
    withoutLogo: false,
    onClickGame: null,
    className: null,
};

function GameCard({ game, selected, small, withoutLogo, onClickGame, className }) {
    const themeClassName = useThemeClassName(styles);
    const { sportGame = null } = game || {};

    const { teamAway = null, teamHome = null } = sportGame || {};
    const teams = useMemo(
        () => (teamAway !== null && teamHome !== null ? [teamAway, teamHome] : []),
        [teamAway, teamHome],
    );

    const onClick = useCallback(() => {
        onClickGame(game);
    }, [onClickGame]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.selected]: selected,
                    [styles.small]: small,
                },
                themeClassName,
                className,
            ])}
        >
            <Button onClick={onClick} className={styles.button}>
                <div className={styles.inner}>
                    <div className={styles.badge}>
                        <SportLivePeriod sportGame={sportGame} inline />
                    </div>
                    <div className={styles.teams}>
                        {teams.map((currentTeam) => {
                            const {
                                name = null,
                                // location = null,
                                abbreviation = null,
                                id: teamId = null,
                                logo = null,
                                goals = 0,
                            } = currentTeam || {};
                            const { url: logoUrl = null } = logo || {};
                            return (
                                <div className={styles.team} key={`team-${teamId}`}>
                                    {logoUrl !== null && !withoutLogo ? (
                                        <img className={styles.logo} src={logoUrl} alt={name} />
                                    ) : null}
                                    <span className={styles.location}>{abbreviation}</span>
                                    <span className={styles.goals}>{goals}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.bottom}>
                    {!selected ? (
                        <div className={styles.label}>
                            <FormattedMessage
                                defaultMessage="Select this game"
                                description="Button label"
                            />
                        </div>
                    ) : (
                        <FontAwesomeIcon icon={faCircleCheck} className={styles.icon} />
                    )}
                </div>
            </Button>
        </div>
    );
}

GameCard.propTypes = propTypes;
GameCard.defaultProps = defaultProps;

export default GameCard;
